// checkboxReview.jsx
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './testiReview.css';

/**
 * Component that allows users to select multiple uses for a flower product
 * with improved mobile responsiveness
 */
export const CheckboxReview = ({ id }) => {
  const [selectedUses, setSelectedUses] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const hiddenInputId = `proUsed_${id}`;

  // Check viewport size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Options for flower uses
  const flowerUseOptions = [
    { id: 1, label: 'Centerpieces' },
    { id: 2, label: 'Bridal Bouquet' },
    { id: 3, label: isMobile ? "Bridesmaid's" : "Bridesmaid's Bouquets" },
    { id: 4, label: 'Corsages' },
    { id: 5, label: 'Boutonnieres' },
    { id: 6, label: 'Other' },
  ];

  /**
   * Handles checkbox state changes
   * @param {Object} event - The change event
   */
  const handleChange = event => {
    const isChecked = event.target.checked;
    const value = parseInt(event.target.value, 10);

    if (isChecked) {
      setSelectedUses(prevSelected => [...prevSelected, value]);
    } else {
      setSelectedUses(prevSelected => prevSelected.filter(item => item !== value));
    }
  };

  return (
    <div className="review-form-group">
      <span className="review-usage-label">Used For:</span>
      <div className="review-checkboxes-container">
        {flowerUseOptions.map(option => (
          <div key={option.id} className="review-checkbox">
            <input
              type="checkbox"
              id={`${id}-${option.id}`}
              name={option.label}
              value={option.id}
              checked={selectedUses.includes(option.id)}
              onChange={handleChange}
              className="review-checkbox-input"
              aria-labelledby={`${id}-${option.id}-label`}
            />
            <label
              id={`${id}-${option.id}-label`}
              htmlFor={`${id}-${option.id}`}
              className="review-checkbox-label"
              title={option.id === 3 && isMobile ? "Bridesmaid's Bouquets" : option.label}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
      <input
        type="hidden"
        name={hiddenInputId}
        id={hiddenInputId}
        value={selectedUses.join(',')}
        aria-hidden="true"
      />
    </div>
  );
};

CheckboxReview.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CheckboxReview;
